import { render, staticRenderFns } from "./WTotalSales.vue?vue&type=template&id=32d8d7bb&scoped=true&"
import script from "./WTotalSales.vue?vue&type=script&lang=js&"
export * from "./WTotalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d8d7bb",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WLoading from '@/components/WLoading.vue'
import WSelect from '@/components/WSelect.vue'
autoInstallComponents(component, {WLoading,WSelect})
